import '@/app.css'
import { createInertiaApp } from '@inertiajs/react'
import { createElement } from 'react'
import { createRoot } from 'react-dom/client'
import { applyStoredTheme } from '@/lib/theme'
import { installErrorReporter } from '@/lib/error-reporter'
import { ThemeProvider } from '@/components/ThemeProvider'

// Apply the user's saved theme before first render to prevent flash
applyStoredTheme()
installErrorReporter()

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.tsx')
    const loader = pages[`../pages/${name}.tsx`]
    if (!loader) {
      throw new Error(`Missing Inertia page component: '${name}.tsx'`)
    }
    return loader()
  },
  setup({ el, App, props }) {
    if (el) {
      createRoot(el).render(createElement(ThemeProvider, null, createElement(App, props)))
    }
  },
})
